// src/api/cronApi.js
// EasyPaisa Recording Cron Job API client
// Base: Recording_URL from Config (live: https://reportingeasypaisaapi.webddocsystems.com/)

import { Recording_URL, Auth_KEY } from "../pages/Config";

const API_BASE = `${String(Recording_URL).replace(/\/$/, "")}/api`;

const defaultHeaders = {
  "Content-Type": "application/json",
  Accept: "*/*",
  "X-API-Key": Auth_KEY,
};

async function request(path, options = {}) {
  const res = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers: {
      ...defaultHeaders,
      ...(options.headers || {}),
    },
  });

  let body = null;
  const contentType = res.headers.get("content-type") || "";
  if (contentType.includes("application/json")) {
    body = await res.json();
  } else {
    const text = await res.text();
    try {
      body = text ? JSON.parse(text) : null;
    } catch {
      body = { success: false, message: text || res.statusText };
    }
  }

  if (!res.ok) {
    const err = new Error(body?.message || `HTTP ${res.status}`);
    err.status = res.status;
    err.body = body;
    throw err;
  }

  if (body && body.success === false) {
    const err = new Error(body.message || "Request failed");
    err.body = body;
    throw err;
  }

  return body;
}

function toQuery(params = {}) {
  const q = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v === undefined || v === null || v === "") return;
    q.set(k, String(v));
  });
  const s = q.toString();
  return s ? `?${s}` : "";
}

/* ── Schedules ─────────────────────────────────────────── */

export async function getSchedules(params = {}) {
  return request(`/cron/schedules${toQuery(params)}`);
}

export async function getScheduleById(id) {
  return request(`/cron/schedules/${id}`);
}

export async function createSchedule(payload) {
  return request(`/cron/schedules`, {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export async function updateSchedule(id, payload) {
  return request(`/cron/schedules/${id}`, {
    method: "PUT",
    body: JSON.stringify(payload),
  });
}

export async function toggleSchedule(id, is_enabled) {
  return request(`/cron/schedules/${id}/toggle`, {
    method: "PATCH",
    body: JSON.stringify({ is_enabled }),
  });
}

export async function deleteSchedule(id) {
  return request(`/cron/schedules/${id}`, { method: "DELETE" });
}

export async function runScheduleNow(id) {
  return request(`/cron/schedules/${id}/run-now`, { method: "POST" });
}

/* ── Runs ──────────────────────────────────────────────── */

export async function getRuns(params = {}) {
  return request(`/cron/runs${toQuery(params)}`);
}

export async function getRunById(id) {
  return request(`/cron/runs/${id}`);
}

export async function pauseRun(id) {
  return request(`/cron/runs/${id}/pause`, { method: "POST" });
}

export async function resumeRun(id) {
  return request(`/cron/runs/${id}/resume`, { method: "POST" });
}

export async function cancelRun(id) {
  return request(`/cron/runs/${id}/cancel`, { method: "POST" });
}

/* ── Logs ──────────────────────────────────────────────── */

export async function getCronLogs(params = {}) {
  return request(`/cron/logs${toQuery(params)}`);
}

/* ── Servers (existing) ────────────────────────────────── */

export async function getActiveServers(params = { page: 1, limit: 100 }) {
  return request(`/recording-servers/active${toQuery(params)}`);
}

export { API_BASE };
